import React from 'react';
import { useTranslation } from "react-i18next";


interface ModalProps {
  isOpen: boolean,
  toggle: () => any,
  title: string,
  form: React.ReactElement,
  width?: number;
}
const Modal = (props: ModalProps) => {
  const { t } = useTranslation();

  // TODO to improve (apply to parent or something like this)
  const keyBoardEvent = (event) => {
    //console.log("here");
    if (props.isOpen) {
      switch (event.code) {
        case "Escape": props.toggle(); break;
      }
    }
  }

  if (!props.isOpen) return null;

  return (
    <div id="modal-bg" className="fixed z-40 inset-0 bg-gray-600 bg-opacity-30 flex items-center justify-center animate-fadeIn"
      onMouseDown={event => { if (event.target.id === 'modal-bg') { props.toggle() } }}
      onKeyDown={event => { keyBoardEvent(event) }}
    >
      <div
        id="modal-bg"
        aria-hidden="false"
        className="fixed overflow-y-auto overflow-x-hidden top-0 right-0 left-0 z-50 flex justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        onKeyDown={keyBoardEvent}
      >

        <div
          className="relative p-4 min-w-lg max-h-full"
          style={{ width: ((props.width != null && props.width > 0 && props.width <= 100) ? props.width + '%' : '50%') }}
        >
          <div className="relative rounded-lg rounded-t-lg  bg-slate-100">

            <div className="flex items-center justify-between py-1 px-3 bg-slate-300 rounded-t-lg">
              <h3 className="text-lg font-semibold text-gray-900 "> {props.title} </h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                data-modal-toggle="crud-modal"
                onClick={e => props.toggle()}
              >
                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            {props.form}

          </div>
        </div>
      </div>
    </div>
  );
};


export default Modal;
